import { stagger, timeline, inView } from "motion";

const elm = document.querySelector('.rewards-cards-fan');

const timing = {
  delay: stagger(0.1),
  easing: 'ease-in-out',
  duration: 0.5,
  at: '<'
}

const sequence = [
  [
    '.rewards-cards-fan', {opacity: 1}, {duration: 0.2}
  ],
  [
    '[data-animate-card="1"]',
    { y: ["7%", "0"], x: ["-54%", "-102%"], rotate: ["-6deg", "-38.5deg"] },
    timing
  ],
  [
    '[data-animate-card="2"]',
    { y: ["7%", "-7%"], x: ["-53%", "-60%"], rotate: ["-2deg", "-20deg"] },
    timing
  ],
  [
    '[data-animate-card="3"]',
    { y: ["7%", "-7%"], x: ["-52%", "-24%"], rotate: ["2deg", "2deg"] },
    timing
  ],
  [
    '[data-animate-card="4"]',
    { y: ["7%", "0"], x: ["-51%", "13%"], rotate: ["6deg", "20.5deg"] },
    timing
  ],
]

window.addEventListener("DOMContentLoaded", () => {
  if (animationsEnabled) {
    inView('.rewards-cards-wrapper', () => {
      timeline(sequence);
    });
  } else {
    elm.style.opacity = 1;
  }
});
